<template>
    <header class="navbar navbar-header navbar-header-fixed">
        <a href="" id="sidebarMenuOpen" class="burger-menu"><i data-feather="arrow-left"></i></a>
        <div class="navbar-brand">
            <a href="#" class="aside-logo"><img src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/logo.png" height="40px" width="100px"/>
            </a></div><!-- navbar-brand -->
        <div id="navbarMenu" class="navbar-menu-wrapper">
            <div class="navbar-menu-header">
                <a href="../index.html" class="df-logo">dash<span>forge</span></a>
                <a id="mainMenuClose" href=""><i data-feather="x"></i></a>
            </div><!-- navbar-menu-header -->

        </div><!-- navbar-menu-wrapper -->
        <div class="navbar-right">
            <a href="#" class="btn btn-social"><i class="fab fa-facebook"></i></a>
            <a href="#" class="btn btn-social"><i class="fab fa-instagram"></i></a>
            <a href="#" class="btn btn-social"><i class="fab fa-twitter"></i></a>
            <!--            <a href="https://themeforest.net/item/azia-responsive-bootstrap-4-dashboard-template/22983790" class="btn btn-buy"><i data-feather="shopping-bag"></i> <span>Logout</span></a>-->
        </div><!-- navbar-right -->
    </header><!-- navbar -->
</template>

<script>
    export default {
        name: "AuthHeader"
    }
</script>

<style scoped>

</style>